export var QueryAggregateType;
(function (QueryAggregateType) {
    QueryAggregateType["ENTRIES"] = "entries";
    QueryAggregateType["VALUES"] = "values";
    QueryAggregateType["KEYS"] = "keys";
    QueryAggregateType["COUNT"] = "count";
})(QueryAggregateType || (QueryAggregateType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["DESCENDING"] = "desc";
    SortOrder["ASCENDING"] = "asc";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=query.js.map